import React from "react"
import { Link } from "react-router-dom"
import DefaultLink from "../../../components/DefaultLink"
export default function BlogListingEvolv(){
  return(
    <>
    <section className="bloglist-evolv-area">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-5 col-md-6">
            <h2 className="heading">Evolving Business Document Storage</h2>
              <p>Business document storage is rapidly evolving from traditional physical archives to secure digital systems and workflow solutions that offer faster access , improved organization, stronger data protection. Modern solutions help businesses manage large volumes of records efficiently while reducing operational complexity.</p>
              <DefaultLink to={"/contact"} text="See How"/>
            
          </div>
          <div className="col-lg-6 col-md-6">
              <img src="/assets/images/Blog-listing-evolving.webp" alt="Evolving" />
          </div>
        </div>
      </div>
    </section>
    </>
  )
}